import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import * as React from 'react';
import './schedule.css';

export class Schedule extends React.Component<{}, { thursOpen: boolean, friOpen: boolean, satOpen: boolean }> {

  constructor(props: any) {
    super(props);

    const today = new Date();

    this.state = {
      friOpen: today.getDate() === 7 && today.getMonth() === 5 && today.getFullYear() === 2019,
      satOpen: today.getDate() === 8 && today.getMonth() === 5 && today.getFullYear() === 2019,
      thursOpen: today.getDate() === 6 && today.getMonth() === 5 && today.getFullYear() === 2019,
    };

    this.toggleThurs = this.toggleThurs.bind(this);
    this.toggleFri = this.toggleFri.bind(this);
    this.toggleSat = this.toggleSat.bind(this);
  }

  public toggleThurs() {
    const { thursOpen } = this.state;

    this.setState({ thursOpen: !thursOpen })
  }

  public toggleFri() {
    const { friOpen } = this.state;

    this.setState({ friOpen: !friOpen })
  }

  public toggleSat() {
    const { satOpen } = this.state;

    this.setState({ satOpen: !satOpen })
  }

  public render() {
    const { thursOpen, friOpen, satOpen } = this.state;

    return (
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        <ListItem button={true} onClick={this.toggleThurs}>
          <ListItemText primary="Thursday, Jun 6th" />
          {thursOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={thursOpen} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            <ListItem>
              <ListItemText primary="5p-8p FunFest Grill Tent" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-11p Midway Open" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-11p Raffle Ticket Sales" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-10p 2019 FunFest Silent Auction" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5:15p Art Show Awards in the Big Tent" />
            </ListItem>
            <ListItem>
              <ListItemText primary="8p-10p Knights of Columbus Fry Shack" />
            </ListItem>
            <ListItem>
              <ListItemText primary="8p Local Band Shucking Bubba Acoustic" />
            </ListItem>
          </List>
        </Collapse>
        <ListItem button={true} onClick={this.toggleFri}>
          <ListItemText primary="Friday, Jun 7th" />
          {friOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={friOpen} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            <ListItem>
              <ListItemText primary="5p-11p Midway and Kids Games Open" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-11p Raffle Ticket Sales" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-10p FunFest Grill Tent" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-10p 2019 FunFest Silent Auction" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-10p Knights of Columbus Fry Shack" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5:30p-7:30p Name 10 Trivia in The Big Tent" />
            </ListItem>
            <ListItem>
              <ListItemText primary="8p Local Band Hostile Work Environment" />
            </ListItem>
          </List>
        </Collapse>
        <ListItem button={true} onClick={this.toggleSat}>
          <ListItemText primary="Saturday, Jun 8th" />
          {satOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={satOpen} timeout="auto" unmountOnExit={true}>
          <List component="div" disablePadding={true}>
            <ListItem>
              <ListItemText primary="4p Mass in the Big Tent" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-11p Midway and Kids Games Open" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-10p FunFest Grill Tent" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-8p 2019 FunFest Silent Auction" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-10p Knights of Columbus Fry Shack" />
            </ListItem>
            <ListItem>
              <ListItemText primary="5p-9p Raffle Ticket Sales" />
            </ListItem>
            <ListItem>
              <ListItemText primary="7p The Rick Brunetto Big Band in the Big Tent" />
            </ListItem>
          </List>
        </Collapse>
      </List>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Schedule/index.tsx